import '../src/utils/consoleLog';
//import 'react-app-polyfill/ie9';
//import 'react-app-polyfill/stable';
import React from "react";
import ReactDOM from "react-dom/client";

import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
// import AppTceppsReduxStore from './redux-store/AppTceppsReduxStore';
import AppReduxStore from "./redux-store/AppReduxStore";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <Provider store={AppReduxStore}>
      <App />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
